import InteractiveImageTabs from './interactive-image-tabs';
const els = document.querySelectorAll('.interactive-image-tabs');

for (let el of els) {
    InteractiveImageTabs(el);
}
